export default __webpack_public_path__ + "static/media/img3.53d00c85.jpg";